import { render } from "./NewsCarousel.vue?vue&type=template&id=284baf06&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"

import "./NewsCarousel.vue?vue&type=style&index=0&id=284baf06&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284baf06"]])

export default __exports__